export default "__VITE_ASSET__kLHWyd14__"